import { render, staticRenderFns } from "./customerServicePc.vue?vue&type=template&id=0339baea&scoped=true&"
import script from "./customerServicePc.vue?vue&type=script&lang=js&"
export * from "./customerServicePc.vue?vue&type=script&lang=js&"
import style0 from "./customerServicePc.vue?vue&type=style&index=0&id=0339baea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0339baea",
  null
  
)

export default component.exports